import { render } from "./AllNewsShow.vue?vue&type=template&id=2c4df3bc"
import script from "./AllNewsShow.vue?vue&type=script&lang=js"
export * from "./AllNewsShow.vue?vue&type=script&lang=js"

import "./AllNewsShow.vue?vue&type=style&index=0&id=2c4df3bc&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__